<section class="p-4">
  <h2 class="title mb-4">Enviar consulta</h2>
  <p-card>
    @if (submittedSuccessfully()) {
      <div class="success-message text-center py-5 px-3">
        <i class="pi pi-check-circle success-icon mb-3" aria-hidden="true"></i>
        <h3 class="mb-3">Consulta enviada correctamente</h3>
        <p class="mb-2">
          Hemos recibido tu solicitud y nuestro equipo la revisará a la mayor brevedad posible.
        </p>
        <p class="mb-4 text-secondary">
          Nos pondremos en contacto contigo a través de los datos facilitados. Gracias por confiar
          en nosotros.
        </p>
        <p-button
          label="Ir al inicio"
          icon="pi pi-home"
          severity="primary"
          (onClick)="goToHome()"
        />
      </div>
    } @else {
      <form [formGroup]="form" class="row">
        @if ($core.selectedBuilding()?.tenantName; as tenantName) {
          <p-floatlabel class="col-4" variant="in">
            <input
              readonly
              pInputText
              type="text"
              id="tenantName"
              class="w-100"
              [value]="tenantName"
            />
            <label class="ps-2" for="tenantName">Nombre de contacto</label>
          </p-floatlabel>
        }
        <p-floatlabel class="col-4" variant="in">
          <input
            pInputText
            type="contactInfo"
            id="contactInfo"
            class="w-100"
            formControlName="contactInfo"
            autocomplete="contactInfo"
          />
          <label class="ps-2" for="contactInfo">Datos de contacto (email, teléfono...)</label>
        </p-floatlabel>
        <p-floatlabel class="col-4" variant="in">
          <p-select
            formControlName="reason"
            [options]="reasons"
            optionValue="value"
            [fluid]="true"
            inputId="reason"
            optionLabel="option"
            class="w-full md:w-56"
          />
          <label class="ps-2" for="reason">Motivo</label>
        </p-floatlabel>
        <p-floatlabel class="mt-4" variant="in">
          <textarea
            pTextarea
            id="in_label"
            formControlName="message"
            rows="5"
            cols="30"
            style="resize: none"
            class="w-100"
          ></textarea>
          <label class="ps-2" for="in_label">¿Qué nos quieres decir?</label>
        </p-floatlabel>

        <strong>Adjuntar archivos</strong>
        <p class="text-secondary small mb-2 mt-1">
          Solo se pueden subir imágenes o documentos PDF. Formatos permitidos: JPG, PNG y PDF.
        </p>
        <p-fileUpload
          mode="advanced"
          [multiple]="true"
          accept=".jpg,.jpeg,.png,.pdf"
          maxFileSize="5000000"
          [showUploadButton]="false"
          [showCancelButton]="false"
          (onSelect)="onUpload($event)"
          #fileUpload
        >
          <ng-template pTemplate="empty">
            <div>Arrastra los archivos para subirlos (JPG, PNG o PDF, 5MB máximo).</div>
          </ng-template>

          <ng-template pTemplate="file" let-file let-index="index">
            <div class="file-item">
              <!-- Preview imagen -->
              @if (isImage(file)) {
                <img [src]="file.objectURL" class="image-preview" />
              }

              <!-- Icono PDF -->
              @if (isPdf(file)) {
                <div class="pdf-preview">
                  <i class="pi pi-file-pdf"></i>
                </div>
              }

              <!-- Info -->
              <div class="file-info">
                <span>{{ file.name }}</span>
                <small>{{ file.size | number }} bytes</small>
              </div>

              <!-- Botón eliminar -->
              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"
                (click)="removeFile(file, index, fileUpload)"
              ></button>
            </div>
          </ng-template>
        </p-fileUpload>

        @if (uploadedFiles.length > 0) {
          <strong class="mt-2">Archivos insertados</strong>
          <!-- <ul> -->
          @for (file of uploadedFiles; track file) {
            <div class="file-item">
              <!-- Preview imagen -->
              @if (isImage(file)) {
                <img [src]="file.objectURL" class="image-preview" />
              }

              <!-- Icono PDF -->
              @if (isPdf(file)) {
                <div class="pdf-preview">
                  <i class="pi pi-file-pdf"></i>
                </div>
              }

              <!-- Info -->
              <div class="file-info">
                <span>{{ file.name }}</span>
                <!-- <small>{{ file.size | number }} bytes</small> -->
              </div>
            </div>
          }
          <!-- </ul> -->
        }
        <div class="d-flex">
          <p-button
            icon="pi pi-send"
            (onClick)="submit()"
            class="mt-3 ms-auto"
            severity="primary"
            label="Enviar consulta"
          />
        </div>
      </form>
    }
  </p-card>
</section>
